import { useSyncExternalStore } from "react";
export function useLocalStorage(key, initialValue) {
  let cachedValue = initialValue;
  let cachedRawValue = null;
  function subscribe(onStoreChange) {
    function handleStorageChange(e) {
      if (e.key === key) {
        onStoreChange();
      }
    }
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }
  function getSnapshot() {
    try {
      const item = window.localStorage.getItem(key);

      // Only parse if the raw value has changed
      if (item !== cachedRawValue) {
        cachedRawValue = item;
        cachedValue = item ? JSON.parse(item) : initialValue;
      }
      return cachedValue;
    } catch (error) {
      return initialValue;
    }
  }
  function getServerSnapshot() {
    return initialValue;
  }
  const value = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  function setValue(newValue) {
    try {
      const valueToStore = newValue instanceof Function ? newValue(value) : newValue;
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      window.dispatchEvent(new StorageEvent("storage", {
        key,
        newValue: JSON.stringify(valueToStore)
      }));
    } catch (error_0) {
      console.error(`Error setting localStorage key "${key}":`, error_0);
    }
  }
  return [value, setValue];
}